import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import s from './SupportPage.module.css';

const SUPPORT_EMAIL = 'support@quadratik.ai';

const SupportPage = () => {
    const { user, loading } = useAuth();
    const history = useHistory();
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!loading && !user) {
            history.replace('/loginsignup');
        }
    }, [loading, user, history]);

    if (loading) {
        return (
            <div className={s.SupportPage}>
                <div className={s.inner}>Loading...</div>
            </div>
        );
    }

    if (!user) return null;

    const handleCopy = () => {
        navigator.clipboard.writeText(SUPPORT_EMAIL);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className={s.SupportPage}>
            <div className={s.inner}>
                <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Quadratik logo" className={s.logo} />
                <h1 className={s.header}>Support</h1>
                <p className={s.subHeader}>We're here to help.</p>
                <p className={s.description}>
                    Have a question, run into an issue, or want to give feedback? Click the email below to copy it, then reach out from your email of choice.
                </p>
                <button type="button" onClick={handleCopy} className={s.emailButton}>
                    {copied ? 'Copied' : SUPPORT_EMAIL}
                </button>
            </div>
        </div>
    );
};

export default SupportPage;
